import { AxiosInstance } from 'axios';

import { StoreModel } from '../../models/Index';
import { ErrorCodes } from '../constants/Authorization';

export function UseErrorInterceptor(instance: AxiosInstance, Store: StoreModel) {
    instance.interceptors.response.use(_ => _, (error) => errorsInterceptor(error, Store));
}

function errorsInterceptor(error: any, Store: StoreModel) {
    const { response } = error;

    // Client errors
    if (response && response.status >= 400) {
        const params = response.config.params || {};

        const errorDescription = Store.configuration.parseError(response);

        // check if envrionment error
        if (response.status === 403
            && errorDescription.code === ErrorCodes.invalidEnvironment) {

            //in this case we just reload page, since response contains Cookie with valid environment 
            //and next request with always go to valid environment (it's configured by Tech Support Team)
            window.location.reload();

            return Promise.reject(response);
        }

        if (response.status === 401
            && !params.__isRetryRequest) {

            // if it's internal mode, then server should return redirect url in 'location' header, which will point to SSO login page
            if (!response.headers.location) {
                console.error("No redirect url to sso");
            } else {
                // Redirect to SSO
                window.location = response.headers.location;
                return Promise.reject(response);
            }
        }

        //TODO: error modal UI
        console.error(error, errorDescription);
        // alert(`Error was occured. HttpCode: ${errorDescription.httpCode}, errorCode: ${errorDescription.code}, message: ${errorDescription.message}. There will be good modal with error description in future`)
    }

    return Promise.reject(response);
}
